export default class WeightedChoiceBase {

    intentionLevel = 2;
    _intentionFunction = null;

    constructor(gameController, aiPackage) {
        this._gameController = gameController;
        this._aiPackage = aiPackage;
        this._gameData = gameController.gameData;
        this._gamePlayerData = gameController.gamePlayerData;
        this._lodging = this._gamePlayerData.lodging;
        this._station = this._gamePlayerData.station;
        this._storage = this._gamePlayerData.storage;
        this.setIntentionLevel();
        this._weight = 0;
    }

    setIntentionLevel = (intentionLevel=2) => {
        this.intentionLevel = intentionLevel;
    }

    getActionWeight = () => {
        this._whatIsMyIntentionalWeight();
        return this._weight;
    }

    _whatIsMyIntentionalWeight = () => {
        this._intentionFunctions = {};
        this._intentionFunctions[-1] = this._hate;
        this._intentionFunctions[0] = this._ambivalent;
        this._intentionFunctions[1] = this._novice;
        this._intentionFunctions[2] = this._reasonable;
        this._intentionFunctions[3] = this._persistent;
        this._intentionFunctions[4] = this._unreasonable;
        this._intentionFunctions[5] = this._obsessed;
        this._intentionFunction = this._intentionFunctions[this.intentionLevel];
        return this._intentionFunction();
    }

    _hate = () => {
        this._weight += -1;
    }
    _ambivalent = () => {
        this._weight += 0;
    }
    _novice = () => {
        throw new Error('Not Implemented');
    }

    _reasonable = () => {
        throw new Error('Not Implemented');
    }

    _persistent = () => {
        throw new Error('Not Implemented');
    }

    _unreasonable = () => {
        throw new Error('Not Implemented');
    }

    _obsessed = () => {
        throw new Error('Not Implemented');
    }
}
